<template>
  <div class="full-con" :style="{background:bgColor}">
    <div class="full-screen-svg" id="fullScreenSvg" v-html="svgString"></div>
    <div class="full-close" @click="closeFullShow">
      <i class="el-icon-close"></i>
    </div>
  </div>
</template>

<script>
import {inToPx} from "@/utils/tools";

export default {
  name: "FullScreenShow",
  props: {
    bgColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      svgString: ""
    }
  },
  methods: {
    init(svgString) {
      if (!svgString) return;
      this.svgString = svgString;
      this.$nextTick(() => {
        this.initSvg();
      })
    },
    initSvg() {
      let dom = $("#fullScreenSvg").children("svg").get(0);
      if (dom) {
        // dom.removeAttribute("viewBox");
        $(dom).width("100%");
        $(dom).height("100%");
        /*let d = document.getElementById(`fullScreenSvg`);
        let wid1 = dom.width.animVal.value;
        let wid2 = d.clientWidth;
        let he1 = dom.height.animVal.value;
        let he2 = d.clientHeight;
        let x = inToPx(wid1, wid2, he1, he2);*/
        let obj = svgPanZoom(dom, {
          zoomEnabled: true,
          minZoom: 0.1
        });
        // dom.setAttribute("transform", `scale(${x})`); // —— safari浏览器、partsloader客户端不支持 换下面一种
        obj.zoom(1, true);
        obj.setZoomScaleSensitivity(0.5);
      }
    },
    closeFullShow() {
      this.svgString = "";
      this.$store.dispatch("app/setFullShow", {isShow: false, svgStr: this.svgString, bgColor: ""})
    },
  }
}
</script>

<style scoped lang="scss">
.full-con {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 10000;

  .full-screen-svg {
    //width: 100%;
    //height: 100%;

    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #000000;
    cursor: pointer;
    height: 100%;
  }

  .full-close {
    position: fixed;
    top: 20px;
    right: 20px;
    width: 20px;
    height: 20px;
    background: #5d8ff8;
    color: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
